import { customVersionComparator } from "../../../../helpers/coappDataGridUtils";
import CoAppDataGridDateTimeCell from "../../../global/components/datagrid/CoAppDataGridDateTimeCell";
import CoAppDataGridNameCell from "../../../global/components/datagrid/CoAppDataGridNameCell";
import CoAppDataGridSkeletonCell from "../../../global/components/datagrid/CoAppDataGridSkeletonCell";
import { WorkstationSwitch } from "../styled/workstation.styled";

export const workstationColumns = ["serialNumber", "killSwitchActive", "comment", "hostName", "ip", "macAddress", "lastLogUpload", "lastPhoneHome"];

export const getWorkstationManagementColumns = (
	handleKillSwitchModalToggle,
	loading
) => [
	{
		field: "serialNumber",
		headerName: "Serial Number",
		sortable: true,
		flex: 1,
		editable: false,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "killSwitchActive",
		headerName: "Kill Switch Status",
		sortable: true,
		flex: 1,
		editable: true,
		type: "boolean",
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={
					<WorkstationSwitch
						checked={params.row.killSwitchActive}
						disabled={false}
						onChange={(e) => handleKillSwitchModalToggle(params.row, params.row.killSwitchActive ? true : false)}
					/>
				}
				isLoading={loading}
			/>
		)
	},
	{
		field: "comment",
		headerName: "Comment",
		sortable: true,
		flex: 1,
		editable: true,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<>{params.value}</>}
				isLoading={loading}
			/>
		)
	},
	{
		field: "hostName",
		sortable: true,
		headerName: "Computer Name",
		flex: 1,
		editable: false,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "ip",
		sortable: true,
		headerName: "Internal IP",
		flex: 1,
		editable: false,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "macAddress",
		sortable: true,
		headerName: "Mac Address",
		flex: 1,
		editable: false,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "extensionVersion",
		headerName: "Extension Version",
		flex: 1,
		editable: false,
		sortComparator: customVersionComparator,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "lastLogUpload",
		headerName: "Last Log Upload",
		sortable: true,
		flex: 1,
		editable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "lastPhoneHome",
		headerName: "Last extension heartbeat",
		sortable: true,
		flex: 1,
		editable: false,
		valueGetter: (params) => !params ? null : new Date(params),
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridDateTimeCell value={params.value} />}
				isLoading={loading}
			/>
		)
	},
	{
		field: "companionVersion",
		headerName: "Companion Version",
		flex: 1,
		editable: false,
		sortComparator: customVersionComparator,
		valueGetter: (params) => (params === "" || params === null) ? " " : params,
		renderCell: (params) => (
			<CoAppDataGridSkeletonCell
				cellToRender={<CoAppDataGridNameCell item={{ name: params.value }} />}
				isLoading={loading}
			/>
		)
	}
];